/* eslint import/prefer-default-export: 0 */

// dependencies
import { fromJS } from "immutable";
import { CreateProcess } from "redux-process";

// utils
import objectToQueryString from "Utils/objectToQueryString";

// selectors
import { getCurrentEnvironmentName } from "Selectors/app";

export const getReviewReportsWithSnapshots = CreateProcess({
	method: "GET",
	name: "getReviewReportsWithSnapshots",
	type: "REVIEWREPORTSNAPSHOTS:GET",

	request: (props, { getState }) => {
		const state = getState();
		const queryString = objectToQueryString(props);
		const environment = getCurrentEnvironmentName(state);

		return {
			url: `/${environment}/review-snapshots/?${queryString}`,
		};
	},

	success: (response) => fromJS(response.data),
});

export const getReviewReportSnapshots = CreateProcess({
	method: "GET",
	name: "getReviewReportSnapshots",
	type: "REVIEWREPORTSNAPSHOTS:GET",

	request: (props, { getState }) => {
		const state = getState();
		const queryString = objectToQueryString(props.query);
		const environment = getCurrentEnvironmentName(state);

		return {
			url: `/${environment}/review-snapshots/${props.reportID}/${props.authorID}/?${queryString}`,
		};
	},

	success: (response) => fromJS(response.data),
});
